import React, { useState } from "react";
import "./styles.scss";

import minusIcon from "../../assets/icons/icons8-minus-96.png"
import { RefEmailDialogBox } from "../refEmailDialog";
import closeIcon from "../../assets/icons/x-circle.svg"
import addIcon from "../../assets/icons/add.png"
import { Link } from "react-router-dom";

type Tprop = {
    show: boolean
    setShow: (open: boolean) => void
}

export const RefPhoneDialogBox: React.FC<Tprop> = ({ show, setShow }) => {
    const [show1, setShow1] = useState(false)
    const [count, setCount] = useState<number>(1);

    const handleAddInput = (event: any) => {
        setCount(count + 1);
    }

    const handleDeleteInput = (event: any) => {
        console.log(event.target.parentElement.parentElement)
        event.target.parentElement.parentElement.remove()
    }

    const handleSend = () => {
        setShow1(true)
    }


    return (
        <div className="phone-dialog-box">
            {show1 && <RefEmailDialogBox show={show1} setShow={setShow1} />}
            <div className="box">
                <div className="header flex flex-row basis-3/4">
                    <div className="heading-text">
                        <h1 className="dialog-heading">Please enter the Mobile Number(s): </h1>
                    </div>
                    <div className="close1 flex flex-rowreverse basis-1/4">
                        <div className="dialog-btn-close-lg" onClick={() => { setShow(false) }}>
                        <img src={ closeIcon } alt="not-found" />
                        </div>
                    </div>
                </div>

                {/* <div className="space"></div> */}

                <div className="mobile-no-field">
                    <div className="label basis-1/2">
                        <label htmlFor="mobile-no" className="mobile-label">Mobile Number:</label>
                    </div>

                    <div className="input basis-1/2">
                        {[...Array(count)].map((e, i) => {
                            return (
                                <>
                                    <div key={i} id={`${i}`} className="input add-input">
                                        <input type="text" name="mobile-no" className="mobile-input" id="mobile-no" />
                                        {i !== 0 && <button className="delete-btn" onClick={handleDeleteInput}><img className="delete-img" src={minusIcon} alt="notFound" /></button>}
                                    </div>
                                    {i === count-1 && <div className="icon">
                                        <button className="add-btn" onClick={handleAddInput}>
                                            <img src={addIcon} alt="not-found" />
                                        </button>
                                    </div>}
                                </>
                            )
                        })}
                    </div>


                </div>

                <div className="message-field flex flex-row">
                    <div className="label basis-1/2">
                        <label htmlFor="message" className="message-label">Message:</label>
                    </div>
                    <div className="input basis-1/2">
                        <div className="msg-text">
                            <h1 className="dialog-heading">Hey buddy,</h1>
                            <div className="space"></div>
                            <p>Parking Hero gives pedestrians a free way to notfiy drivers that their car is about to get a parking ticket!!!</p>
                            <div className="space"></div>
                            <p>Becoming a Parking Hero is quick and easy You can learn more by going to <Link to={'#'}>www.Parking Hero.com</Link></p>
                            <div className="space"></div>
                            <p>Use my Referral Code to get Benefits!!!</p>
                            <div className="space"></div>

                            <div className="ref-code">
                                <p>Code:</p><h1 className="dialog-heading">HJKLMLS487UL</h1>
                            </div>

                        </div>
                    </div>
                    {/* <div className="icon basis-1/6">
                    </div> */}
                </div>

                <div className="button-field flex flex-row">
                    <div className="label basis-1/2">
                    </div>
                    <div className="button basis-1/2">
                        <button className="dialog-btn" onClick={handleSend} >Send</button>
                    </div>
                    {/* <div className="icon basis-1/6"> */}
                    {/* </div> */}
                </div>
            </div>

        </div>
    );
};